<template>
  <div class="max-w-4xl mx-auto">
    <!-- 页面标题 -->
    <div class="text-center mb-12">
      <h1 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-neutral-800 mb-4">用户服务条款</h1>
      <p class="text-neutral-500 max-w-2xl mx-auto">本条款适用于所有使用EliteShop平台服务的用户</p>
    </div>

    <div class="bg-white rounded-lg shadow-elevation-1 p-8 space-y-8">
      <!-- 条款更新时间 -->
      <div class="text-sm text-neutral-500 border-b border-neutral-200 pb-4">
        <p>最后更新时间：2025年1月1日</p>
        <p class="mt-1">生效时间：2025年1月1日</p>
      </div>

      <!-- 接受条款 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">一、接受条款</h2>
        <p class="text-neutral-600 mb-3">
          1.1 您通过点击"同意"、注册账号、使用EliteShop（以下简称"平台"）服务，即表示您同意本条款的所有内容。
        </p>
        <p class="text-neutral-600 mb-3">
          1.2 如果您不同意本条款，请不要使用我们的服务。
        </p>
        <p class="text-neutral-600">
          1.3 我们有权根据法律法规和业务发展需要更新本条款，更新后的条款将通过平台公告，
          继续使用服务即表示您同意更新后的条款。
        </p>
      </section>

      <!-- 用户注册 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">二、用户注册</h2>
        <h3 class="font-medium text-lg mb-2">2.1 注册条件</h3>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc mb-4">
          <li>年满18周岁的自然人，或具备完全民事行为能力的主体</li>
          <li>提供真实、准确、完整的注册信息</li>
          <li>遵守国家法律法规和平台规则</li>
        </ul>

        <h3 class="font-medium text-lg mb-2">2.2 账号安全</h3>
        <p class="text-neutral-600 mb-3">
          2.2.1 您应对账号和密码的安全负责，妥善保管账号信息。
        </p>
        <p class="text-neutral-600 mb-3">
          2.2.2 如发现账号被盗用，应立即通知平台，平台将协助处理。
        </p>
        <p class="text-neutral-600">
          2.2.3 因您自身原因导致账号被盗用造成的损失，由您自行承担。
        </p>
      </section>

      <!-- 用户行为规范 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">三、用户行为规范</h2>
        <p class="text-neutral-600 mb-3">
          3.1 您承诺在使用平台服务时，遵守以下规定：
        </p>
        <div class="bg-neutral-50 p-4 rounded-lg mb-4">
          <h4 class="font-medium mb-2">禁止行为：</h4>
          <ul class="space-y-1 text-neutral-600 pl-5 list-disc">
            <li>发布、传播违法、违规、淫秽、暴力等不良信息</li>
            <li>盗用他人账号、冒用他人身份</li>
            <li>恶意刷单、刷评、套取优惠</li>
            <li>利用平台进行欺诈、洗钱等违法活动</li>
            <li>攻击、侵入平台系统，破坏平台正常运行</li>
            <li>发布广告、垃圾信息、骚扰信息</li>
            <li>其他违反法律法规和公序良俗的行为</li>
          </ul>
        </div>
        <p class="text-neutral-600">
          3.2 如您违反上述规定，我们有权采取警告、限制功能、冻结账号、注销账号等措施，
          情节严重的将移交司法机关处理。
        </p>
      </section>

      <!-- 订单与交易 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">四、订单与交易</h2>
        <h3 class="font-medium text-lg mb-2">4.1 订单成立</h3>
        <p class="text-neutral-600 mb-3">
          4.1.1 您提交订单并完成支付后，订单即成立，双方均应履行合同义务。
        </p>
        <p class="text-neutral-600 mb-3">
          4.1.2 如商品缺货、价格错误等原因导致无法发货，我们将通知您并全额退款。
        </p>

        <h3 class="font-medium text-lg mb-2">4.2 价格与支付</h3>
        <p class="text-neutral-600 mb-3">
          4.2.1 商品价格以提交订单时的价格为准，价格变动不影响已成立的订单。
        </p>
        <p class="text-neutral-600 mb-3">
          4.2.2 您应在规定时间内完成支付，逾期未支付的订单将自动取消。
        </p>
        <p class="text-neutral-600">
          4.2.3 支付过程中如发生异常，应及时联系客服处理。
        </p>

        <h3 class="font-medium text-lg mb-2">4.3 配送与收货</h3>
        <p class="text-neutral-600 mb-3">
          4.3.1 我们将按照您提供的地址配送商品，配送时间以商品详情页标注为准。
        </p>
        <p class="text-neutral-600 mb-3">
          4.3.2 您应在收货时查验商品，如发现破损、缺失等问题，应当场拒收并联系客服。
        </p>
        <p class="text-neutral-600">
          4.3.3 签收后发现的商品问题，应在24小时内联系客服并提供相关证据。
        </p>
      </section>

      <!-- 知识产权 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">五、知识产权</h2>
        <p class="text-neutral-600 mb-3">
          5.1 平台的商标、logo、软件、内容等知识产权均归我们所有。
        </p>
        <p class="text-neutral-600 mb-3">
          5.2 未经授权，您不得复制、修改、传播、使用平台的知识产权。
        </p>
        <p class="text-neutral-600 mb-3">
          5.3 您在平台发布的内容，授予我们非独家、永久、免费的使用权，用于平台运营。
        </p>
        <p class="text-neutral-600">
          5.4 如您认为平台内容侵犯了您的知识产权，可联系我们要求删除。
        </p>
      </section>

      <!-- 免责声明 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">六、免责声明</h2>
        <p class="text-neutral-600 mb-3">
          6.1 因不可抗力（自然灾害、政策调整、网络故障等）导致无法提供服务，我们不承担责任。
        </p>
        <p class="text-neutral-600 mb-3">
          6.2 平台提供的商品信息由商家提供，我们仅进行形式审核，不保证信息的准确性。
        </p>
        <p class="text-neutral-600 mb-3">
          6.3 因您的设备、网络、操作等原因导致的损失，由您自行承担。
        </p>
        <p class="text-neutral-600">
          6.4 我们仅提供交易平台服务，不参与具体交易，买卖双方的纠纷由双方自行解决。
        </p>
      </section>

      <!-- 服务终止 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">七、服务终止</h2>
        <h3 class="font-medium text-lg mb-2">7.1 用户终止</h3>
        <p class="text-neutral-600 mb-3">
          您可以随时注销账号终止服务，注销前应处理完未完成的订单和交易。
        </p>

        <h3 class="font-medium text-lg mb-2">7.2 平台终止</h3>
        <p class="text-neutral-600 mb-3">
          7.2.1 如您违反本条款，我们有权终止服务，暂停或注销您的账号。
        </p>
        <p class="text-neutral-600 mb-3">
          7.2.2 我们有权根据业务调整终止部分或全部服务，终止前将提前30天公告。
        </p>
        <p class="text-neutral-600">
          7.2.3 服务终止后，我们仍将保护您的个人信息安全。
        </p>
      </section>

      <!-- 争议解决 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">八、争议解决</h2>
        <p class="text-neutral-600 mb-3">
          8.1 因使用平台服务产生的争议，双方应友好协商解决。
        </p>
        <p class="text-neutral-600 mb-3">
          8.2 协商不成的，任何一方均可向平台所在地有管辖权的人民法院提起诉讼。
        </p>
        <p class="text-neutral-600">
          8.3 本条款的解释适用中华人民共和国法律。
        </p>
      </section>

      <!-- 联系方式 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">九、联系方式</h2>
        <p class="text-neutral-600 mb-3">
          如您对本条款有任何疑问，可通过以下方式联系我们：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc">
          <li>客服热线：400-123-4567</li>
          <li>客服邮箱：service@eliteshop.com</li>
          <li>联系地址：北京市朝阳区建国路88号 Elite大厦 18层</li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfService'
}
</script>